// extracted by mini-css-extract-plugin
module.exports = {"ru8lzzc":"ru8lzzc","resetter":"resetter","title":"title","description":"description"};